// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ath {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  padding: 14px 5px 14px 20px !important;
  text-align: left;
  /* background-color:#32c89614; */
}

.Atd {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  padding: 14px 5px 14px 20px !important;
  text-align: left;
}

.MainAssigned {
  max-width: 100%;
}

.detailsDD {
  border-radius: 6px;
  border: none;
  background-color: #79c6e9;
  padding: 5px;
}

.detailsDD:hover {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Css/Assigned.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".Ath {\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 14px 5px 14px 20px !important;\r\n  text-align: left;\r\n  /* background-color:#32c89614; */\r\n}\r\n\r\n.Atd {\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 14px 5px 14px 20px !important;\r\n  text-align: left;\r\n}\r\n\r\n.MainAssigned {\r\n  max-width: 100%;\r\n}\r\n\r\n.detailsDD {\r\n  border-radius: 6px;\r\n  border: none;\r\n  background-color: #79c6e9;\r\n  padding: 5px;\r\n}\r\n\r\n.detailsDD:hover {\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
